import { store } from '@/app/redux/store'; // Import your Redux store

export const backupReduxState = () => {
  try {
    // Get the current Redux state
    const state = store.getState();

    // Serialize the state and store it in localStorage
    localStorage.setItem('mirrorInstallData', JSON.stringify(state));

    console.log(
      'Redux state backed up to localStorage as "mirrorInstallData".'
    );
  } catch (error) {
    console.error('Failed to back up Redux state:', error);
  }
};
